import { useState, useEffect } from "react";
import { certificates } from "./cerList";
import Slider from "react-slick";
import "./CertificatesCarousel.css";

// ⚠️ Import CSS của slick (đặt ở đây hoặc App.js)
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

export default function CertificatesCarousel() {
  const [selected, setSelected] = useState(null);

  // đóng modal bằng ESC
  useEffect(() => {
    const onEsc = (e) => e.key === "Escape" && setSelected(null);
    window.addEventListener("keydown", onEsc);
    return () => window.removeEventListener("keydown", onEsc);
  }, []);

  const settings = {
    dots: true,
    infinite: false,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 4,
    initialSlide: 0,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          initialSlide: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
    // dot pastel
    // appendDots: (dots) => <ul className="certs-dots">{dots}</ul>,
    // customPaging: () => (
    //   <button className="dot-btn" aria-label="Chuyển trang" />
    // ),
  };

  return (
    <section className="cer certs-wrap">
      <h2 className="certs-title">CHỨNG NHẬN CHẤT LƯỢNG SẢN PHẨM</h2>
      <div className="slider-container row">
        <Slider {...settings}>
          {certificates.map((c) => (
            <div
              key={c.id}
              className="col-12 col-xs-6 col-sm-4 col-md-3 cert-slide"
            >
              <figure
                className="cert-card"
                onClick={() => setSelected(c.img)}
                role="button"
                tabIndex={0}
              >
                <img src={c.img} alt={c.alt} loading="lazy" />
                <figcaption>{c.alt}</figcaption>
              </figure>
            </div>
          ))}
        </Slider>
      </div>

      {/* Modal */}
      {selected && (
        <div className="certs-modal" onClick={() => setSelected(null)}>
          <img className="certs-modal-img" src={selected} alt="Xem chứng chỉ" />
        </div>
      )}
    </section>
  );
}
